import { Wallet, Target, GitFork, HeartPulse, Repeat, Globe, type LucideIcon } from "lucide-react";
import { Reveal } from "./motion";

const FEATURES: { icon: LucideIcon; title: string; body: string }[] = [
  { icon: Wallet, title: "Accounts & wallets", body: "Every account and cash wallet in one place, adding up to one net-worth figure." },
  { icon: Target, title: "Budgets & goals", body: "Set budgets and savings goals, and watch progress fill in through the month." },
  { icon: GitFork, title: "Money-flow diagram", body: "The Sankey view above — income in, spending out, the whole month in one shape." },
  { icon: HeartPulse, title: "Mood & spending", body: "Log how you feel next to what you spent, and read the patterns behind the numbers." },
  { icon: Repeat, title: "Recurring automation", body: "Rent, subscriptions and salary repeat on their own — the regular items log themselves." },
  { icon: Globe, title: "Multi-currency", body: "Hold accounts in several currencies with live rates folded into every total." },
];

export function FeaturesSection() {
  return (
    <section id="features" className="bg-card">
      <div className="mx-auto max-w-7xl px-6 py-24 lg:px-10">
        <Reveal>
          <div className="mx-auto max-w-2xl text-center">
            <span className="text-sm font-bold uppercase tracking-widest text-primary-text">Everything else, too</span>
            <h2 className="mt-4 text-4xl font-extrabold tracking-tight text-foreground sm:text-[2.6rem]">Six tools already in the app.</h2>
          </div>
        </Reveal>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 3) * 0.06}>
              <div className="h-full rounded-2xl border border-border bg-background p-7 transition-transform hover:-translate-y-1">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-primary/10">
                  <f.icon className="h-5 w-5 text-primary-text" />
                </span>
                <h3 className="mt-4 text-lg font-bold text-foreground">{f.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{f.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
